import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material';
import { Subject } from 'rxjs';
import { map, scan } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  private spinnerTopRef: OverlayRef = this.cdkSpinnerCreate();
  spins: Subject<boolean> = new Subject();

  constructor(private overlay: Overlay) {
    this.spins.asObservable().pipe(map(val => (val ? 1 : -1)), scan((acc, one) => (acc + one >= 0 ? acc + one : 0), 0)).subscribe(res => {

      if (res === 1) {
        this.showSpinner();
      } else if (res === 0) {
        if (this.spinnerTopRef.hasAttached()) {
          this.stopSpinner();
        }
      }

    });
  }

  private cdkSpinnerCreate() {
    return this.overlay.create({
      hasBackdrop: true, backdropClass: 'dark-backdrop',
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
    });
  }

  showSpinner() {

    if (!this.spinnerTopRef.hasAttached()) {
      this.spinnerTopRef.attach(new ComponentPortal(MatSpinner));
    }

  }

  stopSpinner() {
    this.spinnerTopRef.detach();
  }
}
